<template>
    <div id="PDFView">

        <div v-if="isShowPdf">
            <pdf ref="pdf"
                 :src="pdfUrl"
                 :page="pageNum"
                 :rotate="pageRotate"
                 @password="password"
                 @progress="loadedRatio = $event"
                 @page-loaded="pageLoaded($event)"
                 @num-pages="pageTotalNum=$event"
                 @error="pdfError($event)"
                 @link-clicked="page = $event">
            </pdf>

            <a-row style="margin-top: 20px">
                <a-col v-if="pageTotalNum !== 1" :span="2">
                    <a-button @click.stop="prePage">Previous Page</a-button>
                </a-col>
                <a-col v-if="pageTotalNum !== 1" :span="2" :offset="1">
                    <a-button disabled>{{pageNum}}/{{pageTotalNum}}</a-button>
                </a-col>
                <a-col v-if="pageTotalNum !== 1"  :span="2">
                    <a-button @click.stop="nextPage">Next Page</a-button>
                </a-col>
                <a-col :span="2">
                    <a-button @click.stop="pdfPrintAll">Print All</a-button>
                </a-col>
                <a-col :span="3" >
                    <a-button @click.stop="pdfPrint">Print Current Page</a-button>
                </a-col>
                <a-col :span="2" >
                    <a-button><a :href="pdfUrl" :download="downLoadName" >Download</a></a-button>
                </a-col>
            </a-row>
        </div>
        <div v-if="!isShowPdf" class="errorMsg">This PDF file open failed!</div>
    </div>
</template>

<script>
    import pdf from 'vue-pdf'
    import axios from "axios";
    import path from "../../api/path";
    // import {downloadPDF} from "./pdfApiMethod";

    export default {
        name: "PDFView",
        components: {
            pdf
        },
        data() {
            return {
                pdfUrl: '',
                uP: '',
                pageNum: 1,
                pageTotalNum: 1,
                pageRotate: 0,
                // 加载进度
                loadedRatio: 0,
                curPageNum: 0,
                isShowPdf: true,
                downLoadName: ''
            }
        },
        destroyed() {
        },
        created() {
            this.uP = this.$route.query.pdfName
            if (this.uP && this.uP.length > 0) {
                const arr = this.uP.split('/')
                this.downLoadName = arr[arr.length-1]
            }
            // console.log(this.uP)
            this.pdfUrl = this.uP+ '.pdf'
        },
        methods: {
            prePage() {
                var p = this.pageNum
                p = p > 1 ? p - 1 : this.pageTotalNum
                this.pageNum = p
            },
            nextPage() {
                var p = this.pageNum
                p = p < this.pageTotalNum ? p + 1 : 1
                this.pageNum = p
            },
            password(updatePassword, reason) {
                updatePassword(prompt('Please input password'))
                // console.log('...reason...')
                // console.log(reason)
                // console.log('...reason...')
            },
            pageLoaded(e) {
                this.curPageNum = e
                if ( e) this.isShowPdf = true
            },
            pdfError(error) {
                console.error(error)
                if (error) this.isShowPdf = false
            },
            pdfPrintAll() {
                this.$refs.pdf.print()
            },
            pdfPrint() {
                this.$refs.pdf.print(100, [1, 2])
            },
        }
    }
</script>

<style scoped>
    ::-webkit-scrollbar {
        display: none;
    }

    #PDFView {
        background-color: #ffffff;
        padding: 10px;
        height: 100%;
    }

    .errorMsg{
        color: red;
        font-size: 16px;
        text-align: center;
    }
    .downloadButton{
        border: 1px solid #d5d5d5;
        color: #555555;
        padding: 8px 20px;
        border-radius: 4px;
        height: 30px;
    }
</style>
